import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  static values = {
    scope: String
  }

  declare readonly inputTarget: HTMLInputElement
  declare readonly scopeValue: string

  addImage (): void {
    this.inputTarget.disabled = true
    this.inputTarget.value = ''
  }

  removeImage (): void {
    this.inputTarget.disabled = false
    this.inputTarget.value = ''
  }
}
